// import React, { Component } from "react";
// import paymentService from "app/services/paymentService";
// import { Button, Modal } from "react-bootstrap";
// import { Formik } from "formik";
// import {
//   RenderDateInput,
//   RenderSelectInput,
//   RenderTextInput,
// } from "app/common/renderInput";
// import * as yup from "yup";
// import bankService from "app/services/AdminServices/bankService";
// import moment from "moment";
// import { NotificationManager } from "react-notifications";
// import requisitionService from "app/services/requisitionService";

// const validationModel = yup.object().shape({
//   amount: yup.number().required("Please enter your amount"),
//   referenceNo: yup.string().required("Please enter your Reference No"),
//   requestDate: yup.string().required("Please enter Member type"),
//   bankId: yup.string().required("Please enter Bank Id"),
//   transactionDetails: yup.string().required("Please enter Transaction Details"),
//   transferMethod: yup.string().required("Please enter Transfer Method"),
//   bankCharges: yup.string().required("Please enter Bank Charges"),
// });

// const { getrequisitionForEdit, updateReq, getRequisitionBankList } =
//   requisitionService;

// export class EditReq extends Component {
//   state = {
//     details: [],
//     ReqId: 0,
//     amount: 0,
//     referenceNo: 0,
//     requestDate: "",
//     bankId: 0,
//     transactionDetails: "",
//     transferMethod: "",
//     bankCharges: "",
//     bankList: [],
//     paymentTypeList: [
//       { value: "NEFT", label: "NEFT" },
//       { value: "IMPS", label: "IMPS" },
//       { value: "UPI", label: "UPI" },
//       { value: "RTGS", label: "RTGS" },
//       { value: "ONLINE", label: "ONLINE" },
//     ],
//   };

//   async componentDidUpdate(prevProps, prevState) {
//     //console.log(prevProps,prevState)
//     // const res = await getrequisitionForEdit(this.props.ReqId);
//     // console.log(res);
//     // this.setState({
//     //     details:res.data
//     // })
//   }
//   async componentWillReceiveProps(nextProps, nextState) {
//     if (nextProps.ReqId > 0 && this.state.ReqId != nextProps.ReqId) {
//       this.setState({
//         ReqId: nextProps.ReqId,
//       });
//       const res = await getrequisitionForEdit(nextProps.ReqId);
//       // console.log(res);
//       this.setState({
//         details: res.data,
//       });
//     }
//   }

//   async componentDidMount() {
//     await this.loadBankLists();
//   }

//   loadBankLists = async () => {
//     const response = await getRequisitionBankList();
//     const bankData = response.data;
//     const bankList = bankData.map((x, i) => {
//       return {
//         value: x.id,
//         label: x.bankName,
//       };
//     });
//     // debugger
//     this.setState({
//       bankList,
//     });
//   };

//   render() {
//     const handleSubmit = async (values) => {
//       //   console.log(values);
//       const response = await updateReq(values);
//       // console.log(response);
//       if (response.status === "Success") {
//         setTimeout(async () => {
//           await this.props.loadTransaction();
//           document.getElementsByClassName("close")[0].click();
//           NotificationManager.success("Requisition updated successfully");
//         }, 800);
//       } else {
//         NotificationManager.danger("Sorry! Requisition failed.");
//       }
//     };

//     return (
//       <div
//         className="modal fade"
//         id="editReqPopup"
//         tabIndex="-1"
//         role="dialog"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">
//                 Edit Requisition
//               </h5>
//               <button
//                 type="button"
//                 className="close"
//                 data-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">&times;</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               {this.state.details ? (
//                 <Formik
//                   initialValues={this.state.details}
//                   validationSchema={validationModel}
//                   onSubmit={handleSubmit}
//                   enableReinitialize={true}
//                 >
//                   {({
//                     values,
//                     errors,
//                     touched,
//                     handleChange,
//                     handleBlur,
//                     handleSubmit,
//                     isSubmitting,
//                     isValid,
//                     dirty,
//                     setFieldValue,
//                   }) => {
//                     return (
//                       <form
//                         className="needs-validation"
//                         onSubmit={handleSubmit}
//                         noValidate
//                       >
//                         <div className="form-row">
//                           <RenderTextInput
//                             type="number"
//                             name="amount"
//                             display="Amount"
//                             value={values.amount}
//                             error={errors.amount}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.amount}
//                             required
//                           ></RenderTextInput>

//                           <RenderTextInput
//                             type="text"
//                             name="referenceNo"
//                             display="Reference No"
//                             value={values.referenceNo}
//                             error={errors.referenceNo}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.referenceNo}
//                           ></RenderTextInput>
//                         </div>

//                         <div className="form-row">
//                           {/* <RenderTextInput
//                           type="number"
//                           display="Request Date"
//                           name="requestDate"
//                           value={values.requestDate}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           error={errors.requestDate}
//                           touched={touched.requestDate}
//                           required
//                         ></RenderTextInput> */}

//                           <RenderDateInput
//                             type="date"
//                             display="Request Date"
//                             name="requestDate"
//                             value={
//                               values.requestDate
//                                 ? new moment(values.requestDate).format(
//                                     "YYYY-MM-DD"
//                                   )
//                                 : ""
//                             }
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             error={errors.requestDate}
//                             touched={touched.requestDate}
//                             required
//                           ></RenderDateInput>

//                           {/* <RenderTextInput
//                           type="number"
//                           display="Bank Id"
//                           name="bankId"
//                           value={values.bankId}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           error={errors.bankId}
//                           touched={touched.bankId}
//                           required
//                         ></RenderTextInput> */}

//                           <RenderSelectInput
//                             name="bankId"
//                             display="Bank List"
//                             placeholder="Bank List"
//                             value={values.bankId}
//                             error={errors.bankId}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.bankId}
//                             items={this.state.bankList}
//                             required
//                           ></RenderSelectInput>
//                         </div>

//                         <div className="form-row">
//                           <RenderTextInput
//                             type="text"
//                             display="Transaction Details"
//                             name="transactionDetails"
//                             value={values.transactionDetails}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             error={errors.transactionDetails}
//                             touched={touched.transactionDetails}
//                             required
//                           ></RenderTextInput>
//                           {/* <RenderTextInput
//                           type="number"
//                           display="Transfer Method"
//                           name="transferMethod"
//                           value={values.transferMethod}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           error={errors.transferMethod}
//                           touched={touched.transferMethod}
// items={this.state.paymentTypeList}

//                           required
//                         ></RenderTextInput> */}

//                           <RenderSelectInput
//                             display="Transfer Method"
//                             name="transferMethod"
//                             value={values.transferMethod}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             error={errors.transferMethod}
//                             touched={touched.transferMethod}
//                             items={this.state.paymentTypeList}
//                             required
//                           ></RenderSelectInput>
//                         </div>

//                         <div className="form-row">
//                           <RenderTextInput
//                             type="number"
//                             display="Bank Charges"
//                             name="bankCharges"
//                             value={values.bankCharges}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             error={errors.bankCharges}
//                             touched={touched.bankCharges}
//                             required
//                           ></RenderTextInput>
//                         </div>

//                         <div className="form-row d-flex align-items-center justify-content-center mt-3">
//                           <Button
//                             className="mx-1"
//                             variant="outline-primary"
//                             type="submit"
//                           >
//                             Update
//                           </Button>
//                           <button
//                             type="button"
//                             className="btn btn-secondary"
//                             data-dismiss="modal"
//                           >
//                             Close
//                           </button>
//                         </div>
//                       </form>
//                     );
//                   }}
//                 </Formik>
//               ) : (
//                 ""
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default EditReq;

import React, { Component } from "react";
import paymentService from "app/services/paymentService";
import { Button, Modal } from "react-bootstrap";
import { Formik } from "formik";
import {
  RenderDateInput,
  RenderSelectInput,
  RenderTextInput,
} from "app/common/renderInput";
import * as yup from "yup";
import bankService from "app/services/AdminServices/bankService";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import {
  getrequisitionForEdit,
  updateReq,
  getRequisitionBankList,
} from "app/services/requisitionService";
import { useState } from "react";
import { useEffect } from "react";

const validationModel = yup.object().shape({
  amount: yup.number().required("Please enter your amount"),
  referenceNo: yup.string().required("Please enter your Reference No"),
  requestDate: yup.string().required("Please enter Member type"),
  bankId: yup.string().required("Please enter Bank Id"),
  transactionDetails: yup.string().required("Please enter Transaction Details"),
  transferMethod: yup.string().required("Please enter Transfer Method"),
  bankCharges: yup.string().required("Please enter Bank Charges"),
});

function EditReq({ ReqId, showEditReq, loadTransaction }) {
  const [state, setState] = useState({
    details: [],
    ReqId: 0,
    amount: 0,
    referenceNo: 0,
    requestDate: "",
    bankId: 0,
    transactionDetails: "",
    transferMethod: "",
    bankCharges: "",
    bankList: [],
    paymentTypeList: [
      { value: "NEFT", label: "NEFT" },
      { value: "IMPS", label: "IMPS" },
      { value: "UPI", label: "UPI" },
      { value: "RTGS", label: "RTGS" },
      { value: "ONLINE", label: "ONLINE" },
    ],
  });

  const loadBankLists = async () => {
    const response = await getRequisitionBankList();
    const bankData = response.data;
    const bankList = bankData.map((x, i) => {
      return {
        value: x.id,
        label: x.bankName,
      };
    });

    setState({
      bankList,
    });
  };

  useEffect(() => {
    const getReqData = async () => {
      const res = await getrequisitionForEdit(ReqId);

      setState((prev) => ({ ...prev, details: res.data }));
    };
    if (ReqId) {
      getReqData();
    }
  }, [ReqId]);

  useEffect(() => {
    loadBankLists();
  }, []);
  const handleSubmit = async (values) => {
    const response = await updateReq(values);

    if (response.status === "Success") {
      setTimeout(async () => {
        await loadTransaction();
        document.getElementsByClassName("btn-close")[0].click();
        NotificationManager.success("Requisition updated successfully");
      }, 800);
    } else {
      NotificationManager.danger("Sorry! Requisition failed.");
    }
  };

  return (
    <div>
      <div
        className="modal fade"
        id="editReqPopup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Requisition
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {state.details ? (
                <Formik
                  initialValues={state.details}
                  validationSchema={validationModel}
                  onSubmit={handleSubmit}
                  enableReinitialize={true}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    isValid,
                    dirty,
                    setFieldValue,
                  }) => {
                    return (
                      <form
                        className="needs-validation"
                        onSubmit={handleSubmit}
                        noValidate
                      >
                        <div className="row">
                          <RenderTextInput
                            type="number"
                            name="amount"
                            display="Amount"
                            value={values.amount}
                            error={errors.amount}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.amount}
                            required
                          ></RenderTextInput>

                          <RenderTextInput
                            type="text"
                            name="referenceNo"
                            display="Reference No"
                            value={values.referenceNo}
                            error={errors.referenceNo}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.referenceNo}
                          ></RenderTextInput>
                        </div>

                        <div className="row">
                          <RenderDateInput
                            type="date"
                            display="Request Date"
                            name="requestDate"
                            value={
                              values.requestDate
                                ? new moment(values.requestDate).format(
                                    "YYYY-MM-DD"
                                  )
                                : ""
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.requestDate}
                            touched={touched.requestDate}
                            required
                          ></RenderDateInput>

                          <RenderSelectInput
                            name="bankId"
                            display="Bank List"
                            placeholder="Bank List"
                            value={values.bankId}
                            error={errors.bankId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.bankId}
                            items={state.bankList}
                            required
                          ></RenderSelectInput>
                        </div>

                        <div className="row">
                          <RenderTextInput
                            type="text"
                            display="Transaction Details"
                            name="transactionDetails"
                            value={values.transactionDetails}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.transactionDetails}
                            touched={touched.transactionDetails}
                            required
                          ></RenderTextInput>

                          <RenderSelectInput
                            display="Transfer Method"
                            name="transferMethod"
                            value={values.transferMethod}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.transferMethod}
                            touched={touched.transferMethod}
                            items={state.paymentTypeList}
                            required
                          ></RenderSelectInput>
                        </div>

                        <div className="row">
                          <RenderTextInput
                            type="number"
                            display="Bank Charges"
                            name="bankCharges"
                            value={values.bankCharges}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.bankCharges}
                            touched={touched.bankCharges}
                            required
                          ></RenderTextInput>
                        </div>

                        <div className="d-flex align-items-center justify-content-center mt-3">
                          <Button
                            className="mx-1"
                            variant="outline-primary"
                            type="submit"
                          >
                            Update
                          </Button>
                          <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                          >
                            Close
                          </button>
                        </div>
                      </form>
                    );
                  }}
                </Formik>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditReq;
